declare var angular: any;
import * as _ from 'underscore';
import * as moment from 'moment';
import { keyBy, last, sortBy } from 'lodash';

angular
  .module('UserExamControllers', [])

  .controller('ExamHomeCtrl', [
    '$scope',
    'api',
    '$mdDialog',
    '$mdToast',
    '$window',
    'EXAM',
    '$translate',
    async function(
      $scope,
      api,
      $mdDialog,
      $mdToast,
      $window,
      EXAM,
      $translate
    ) {
      $scope.estimatedScores = await api.getMyEstimatedScores();

      console.log('estimatedScores', $scope.estimatedScores);

      $scope.currentTrainingExam = $window.localStorage.currentTrainingExam
        ? $window.localStorage.currentTrainingExam
        : 'mock';
      $scope.setCurrentTraining = function(current) {
        $window.localStorage.currentTrainingExam = current;
      };

      if ($window.localStorage.dateOfRegister) {
        var freemiumExpiredDate = moment
          .utc(JSON.parse($window.localStorage.dateOfRegister))
          .add(1, 'days');
        $scope.isFreemium = moment.utc().isBefore(freemiumExpiredDate);
      }

      api.sync(api.getResults, function(data) {
        var historics = JSON.parse(JSON.stringify(data));
        historics = _.sortBy(historics, 'id').reverse();

        for (var i = 0; i < historics.length; i++) {
          if (!$scope.mockDone && $scope.main.me.plans.length > 0) {
            var plan = $scope.main.me.plans[0];
            if (
              plan &&
              moment(historics[i]['created_at']).isBetween(
                plan.begin_date,
                plan.end_date
              )
            ) {
              $scope.mockDone = true;
            }
          }

          historics[i]['created_at'] = moment
            .utc(historics[i]['created_at'])
            .format('ll');
        }

        $scope.historics = historics;
      });

      $scope.mockDone = !$scope.main.me.mock;

      $scope.reset = function(ev) {
        let tr = $translate.instant([
          'toasts.ask_end_test.title',
          'toasts.ask_end_test.description',
          'toasts.ask_end_test.ok',
          'toasts.ask_end_test.cancel',
          'toasts.ask_end_test_confirmation'
        ]);

        var confirm = $mdDialog
          .confirm({
            preserveScope: true,
            parent: angular.element(document.body)
          })
          .title(tr['toasts.ask_end_test.title'])
          .textContent(tr['toasts.ask_end_test.description'])
          .ariaLabel('Terminer')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .ok(tr['toasts.ask_end_test.ok'])
          .cancel(tr['toasts.ask_end_test.cancel']);
        $mdDialog.show(confirm).then(
          function() {
            api.endMock().then(function(data) {
              $scope.main.me.profile.current_exam_id = null;
            });
            let text;
            if (EXAM === 'lerobert') {
              text = 'Le test blanc a bien été terminé.';
            } else {
              text = tr['toasts.ask_end_test_confirmation'];
            }
            $mdToast.show(
              $mdToast
                .simple()
                .textContent(text)
                .position('bottom right')
            );
          },
          function() {}
        );
      };
    }
  ])

  .controller('ExamHistoricCtrl', [
    '$scope',
    'api',
    'navbar',
    '$routeParams',
    'examUtils',
    'trainingUtils',
    'exam',
    'audio',
    'EXAM',
    function(
      $scope,
      api,
      navbar,
      $routeParams,
      examUtils,
      trainingUtils,
      exam,
      audio,
      EXAM
    ) {
      if (EXAM === 'lerobert') {
        navbar.goBackAction('Examen', '#!exam');
      } else {
        navbar.goBackAction('Test blanc', '#!examen', 'navbar.exam');
      }

      var supports = {
        listening: [],
        reading: []
      };

      $scope.sections = exam.sections;

      api.getResult($routeParams.id).then(function(data) {
        $scope.userAnswersInput = examUtils.getUsersAnswersInput(
          data.result.answers
        );
        $scope.rawUserAnswersByQuestionId = keyBy(
          data.result.answers,
          'question_id'
        );
        console.log(
          'rawUserAnswersByQuestionId',
          $scope.rawUserAnswersByQuestionId
        );
        data.exam.supports = _.chain(data.exam.supports)
          .sortBy('id')
          .sortBy('part')
          .value();
        audio.init(true, false);
        audio.addTracks(audio.setPlaylist(data.exam.supports, 'exam'));

        var currentPart;
        var index;
        examUtils.integrateCurrentAnswers(
          data.exam.supports,
          data.result.answers
        );

        for (var i = 0; i < data.exam.supports.length; i++) {
          data.exam.supports[i].questions = _.sortBy(
            data.exam.supports[i].questions,
            function(question: any) {
              return question.id;
            }
          );

          // detect if need showHeader
          currentPart = examUtils.showHelp({
            support: data.exam.supports[i],
            currentPart: currentPart
          });
          index = examUtils.indexQuestionsSupport({
            support: data.exam.supports[i],
            index: index
          });
          // add to the good ng-repeat for performance
          if (exam.partIs('reading', data.exam.supports[i].part)) {
            supports.reading.push(data.exam.supports[i]);
          } else {
            supports.listening.push(data.exam.supports[i]);
          }
        }
        examUtils.correctAnswers(supports);
        $scope.supports = supports;
      });
    }
  ])

  .controller('ExamOnCtrl', [
    '$timeout',
    '$scope',
    '$mdDialog',
    '$filter',
    'audio',
    'angularPlayer',
    'navbar',
    'api',
    '$mdSidenav',
    'trainingUtils',
    'examUtils',
    'exam',
    'EXAM',
    'ApiService',
    function(
      $timeout,
      $scope,
      $mdDialog,
      $filter,
      audio,
      angularPlayer,
      navbar,
      api,
      $mdSidenav,
      trainingUtils,
      examUtils,
      exam,
      EXAM,
      ApiService
    ) {
      navbar.goBackAction('Examen', '#!exam', 'navbar.exam');

      /**************
    $scope.supports : contains data from GET
    $scope.data.answer : contains data of the choices user
    $scope.data.finished
    ************/

      $scope.data = {
        answer: {},
        finished: false,
        autoplay: exam.examData.autoplay.initialValue
      };

      $scope.progress = {
        current: {
          part: null,
          started: false,
          selectedSection: null,
          hasNextSupport: null,
          hasPreviousSupport: null
        },
        listening: {
          index: 0,
          total: undefined
        },
        reading: {
          index: 0,
          total: undefined
        }
      };

      var supports = {
        listening: [],
        reading: []
      };

      $scope.exam = true;
      $scope.examData = exam.examData;

      $scope.sections = exam.sections;

      $scope.$on('track:id', function(event, data) {
        $timeout(function() {
          $scope.currentTrackId = data;
        });
      });

      // this for change tabs;
      $scope.setCurrentPart = function(LR) {
        $scope.progress.current.part = LR;
        $scope.progress.current.selectedSection = exam.getSectionById(LR);
        if (!$scope.data.finished) {
          loadSupport(LR);
          var inverse = LR === 'reading' ? 'listening' : 'reading';
          $scope.pause(inverse);
        } else {
          updateCorrectionParts();
        }
      };

      function init() {
        $scope.loading = true;
        // Get data for the toeic from API
        api.getMock().then(function(data) {
          // this for md-tabs

          data.exam.supports = trainingUtils.addTimerToSupports(
            data.exam.supports
          );

          data.exam.supports = _.chain(data.exam.supports)
            .sortBy('id')
            .sortBy('part')
            .value();
          examUtils.integrateCurrentAnswers(data.exam.supports, data.answers);
          $scope.userAnswersInput = examUtils.getUsersAnswersInput(
            data.answers
          );

          $scope.answersByQuestionsId = _.groupBy(data.answers, 'question_id');

          var index;
          var currentPart;

          for (var i = 0; i < data.exam.supports.length; i++) {
            data.exam.supports[i].questions = _.sortBy(
              data.exam.supports[i].questions,
              function(q: any) {
                return q.id;
              }
            );
            // detect if need showHeader
            currentPart = examUtils.showHelp({
              support: data.exam.supports[i],
              currentPart: currentPart
            });

            index = examUtils.indexQuestionsSupport({
              support: data.exam.supports[i],
              index: index
            });

            // add to the good ng-repeat for performance
            if (exam.partIs('reading', data.exam.supports[i].part)) {
              supports.reading.push(data.exam.supports[i]);
            } else {
              supports.listening.push(data.exam.supports[i]);
            }
          }

          $scope.progress.listening.total = supports.listening.length;
          $scope.progress.reading.total = supports.reading.length;

          var time;
          if (!data.answers.length || data.answers.length <= 2) {
            time = 0;
          } else {
            time = 0;
            var deltat = 0;

            // Get the choices of reading
            var questions = _.flatten(
              _.map(supports.reading, function(support) {
                return support.questions;
              })
            );
            var choices = _.flatten(
              _.map(questions, function(question) {
                return question.choices;
              })
            );
            choices = _.map(choices, function(choice) {
              return choice.id;
            });

            var answers = _.filter(data.answers, function(answer: any) {
              return _.contains(choices, answer.choices[0].id);
            });
            answers = _.sortBy(answers, function(answer: any) {
              return answer.created_at;
            });
            for (var i = 0; i < answers.length - 1; i++) {
              deltat =
                ((moment.utc(answers[i + 1].created_at) as any) as number) -
                ((moment.utc(answers[i].created_at) as any) as number);
              deltat = Math.round(deltat / 1000);
              if (deltat < 120) {
                time += deltat;
              }
            }
          }

          let initTimer;
          if (exam.examData.globalTimer) {
            initTimer = exam.examData.globalTimer;
          } else {
            initTimer = 4500;
          }
          if (EXAM === 'delf') {
            let level = $scope.main.me.profile.level;
            if (
              level === 'B1' ||
              level === 'B1-JR' ||
              level === 'A2' ||
              level === 'A2-JR'
            ) {
              initTimer = 8400;
            }
          }
          setTime(initTimer - time); // TODO exam.getTime()

          audio.init(true, false);
          if (exam.examData.playlistAudio) {
            audio.addTracks(audio.setPlaylist(data.exam.supports, 'exam'));
          }
          findCurrentIndexSupport();
          // TODO check if is waiting for findCurrentIndexSupport
          var current_part;
          if (!data.answers.length) {
            current_part = $scope.sections[0].id;
          } else {
            questions = _.flatten(
              _.map(data.exam.supports, function(support: any) {
                return support.questions;
              })
            );
            var question = _.find(questions, function(question) {
              return (
                question.id == data.answers[data.answers.length - 1].question_id
              );
            });
            // TODO Find the current part
            current_part = 'listening'; //(exam.partIs('listening', part)) ? 'listening' : 'reading';
          }
          $scope.setCurrentPart(current_part);
          $scope.loading = false;
          // TODO hack for md-tabs to transform part in index
          $scope.progress.current.partIndex = data.current_part === 'reading';
        });
      }
      init();

      $scope.saveAnswer = async function(
        answer,
        support,
        userAnswerInput = null
      ) {
        let isPEQuestion =
          support.questions?.length === 1 &&
          support?.questions[0]?.choices?.length === 1;

        let answerIdToUpdate = null;

        // Using the last answer if only one question and one choice
        // BEcause the user can't change his answer but can change the extravalue // DELF PE
        if (isPEQuestion) {
          let question = support.questions[0];
          let choices = $scope.answersByQuestionsId[question.id];
          let lastAnswer = last(sortBy(choices, 'id'));
          if (lastAnswer) {
            answerIdToUpdate = lastAnswer.id;
          }
        }

        let x = await api.saveAnswer(
          answer,
          true,
          userAnswerInput,
          answerIdToUpdate
        );

        if (isPEQuestion && !answerIdToUpdate) {
          let question = support.questions[0];
          $scope.answersByQuestionsId[question.id] = [x.answer];
        }

        if (
          $scope.data.autoplay &&
          trainingUtils.checkFinishedSupport(support)
        ) {
          $scope.nextSupport();
        }
      };

      // Get the corrections and results
      $scope.submit = function(ev) {
        $scope.data.finished = true;
        $scope.pause('listening');
        $scope.pause('reading');

        // TODO : issue
        //examUtils.showScore(ev, $scope);

        api.endMock().then(function(data) {
          $scope.data.finished = data;
          // examUtils.integrateAnswers(supports, data.correct_choices); no need in v2 currently
          $scope.results = examUtils.correctAnswers(supports);
          updateCorrectionParts();
        });
      };

      $scope.openRightMenu = function() {
        $mdSidenav('right').toggle();
      };

      function findCurrentIndexSupport() {
        // this is for init
        // check if support is answered
        // update currentIndex
        var part = ['listening', 'reading'];

        for (var k = 0; k < part.length; k++) {
          // -1 correspond to start exam
          var index = -1;
          var LR = part[k];

          for (var i = supports[LR].length - 1; i >= 0; i--) {
            var answered = _.find(supports[LR][i].questions, function(
              question
            ) {
              return question['choice_user'];
            });
            if (answered) {
              index = i;
              break;
            }
          }

          // if last
          if (index === supports[LR].length - 1) {
            $scope.progress[LR].index = index;
          } else {
            $scope.progress[LR].index = index + 1;
          }
        }

        let audioIndex =
          supports.listening[$scope?.progress?.listening?.index]?.id;
        if (audioIndex) {
          audio.goToCurrent(audioIndex);
        }
      }

      function updateCorrectionParts() {
        $scope.correction =
          $scope.progress.current.part === 'listening'
            ? supports.listening
            : supports.reading;
      }

      // Commands to control toeic
      $scope.toggle = function() {
        $scope.progress.current.started ? $scope.pause() : $scope.start();
      };

      $scope.start = function(LR) {
        // if LR do it right
        if (LR) {
          $scope.progress.current.part = LR;
          $scope.progress.current.started = true;
          if (exam.examData.globalTimer) {
            startTimer();
          }

          if (LR === 'listening' && exam.examData.playlistAudio) {
            audio.play();
          } else {
            startTimer();
          }
        } else {
          $scope.start($scope.progress.current.part);
        }
      };

      $scope.pause = function(LR) {
        if (LR) {
          $scope.progress.current.started = false;
          LR === 'listening' ? [audio.pause(), stopTimer()] : stopTimer();
        } else {
          $scope.pause($scope.progress.current.part);
        }
      };

      function hasNextSupport(LR) {
        if ($scope.progress[LR].index === $scope.progress[LR].total - 1) {
          return false;
        }
        return true;
      }

      function hasPreviousSupport(LR) {
        if ($scope.progress[LR].index === 0) return false;
        return true;
      }

      $scope.nextSupport = function() {
        var LR = $scope.progress.current.part;
        if (hasNextSupport(LR)) {
          $scope.progress[LR].index++;
          loadSupport(LR);
        }
      };

      $scope.previousSupport = function() {
        var LR = $scope.progress.current.part;
        if (hasPreviousSupport(LR)) {
          $scope.progress[LR].index--;
          loadSupport(LR);
        }
      };

      function loadSupport(LR) {
        var support = supports[LR][$scope.progress[LR].index];
        $scope.support = support;
        // for button
        $scope.progress.current.hasNextSupport = hasNextSupport(LR);
        $scope.progress.current.hasPreviousSupport = hasPreviousSupport(LR);
      }

      $scope.userAnswersInput = {};
      $scope.checkedOpenGapAnswer = trainingUtils.checkedOpenGapAnswer;

      $scope.timer = {};
      function setTime(time) {
        console.log('tim', time);
        $scope.timer.time = time;
      }
      function getTime() {
        return $scope.timer.time;
      }
      function startTimer() {
        $scope.timer.started = true;
      }
      function stopTimer() {
        $scope.timer.started = false;
      }

      $scope.setAnswersInput = async (question, $ev) => {
        $scope.userAnswersInput[question.id] = $ev;
        console.log('d', $scope.userAnswersInput[question.id]);
      };

      $scope.upload = async question => {
        // We assume it's this type
        // if ($scope.userAnswersInput && $scope.userAnswersInput.type) {
        // }

        const filePath = `/users/${
          api.data.me.user.id
        }/delf/${new Date().toISOString()}.mp3`;
        const upload = await ApiService.uploadFile(
          $scope.userAnswersInput[question.id],
          filePath
        );
        $scope.userAnswersInput = {
          [question.id]: upload
        };

        $scope.support.questions[0].choice_user = question.choices[0].id;
      };

      $scope.uploadAndFinished = async () => {
        let question = $scope.support.questions[0];
        await $scope.upload(question);
        // $scope.checkFinished(isFinished);
        $scope.saveAnswer(
          question.choice_user,
          $scope.support,
          $scope.userAnswersInput[question.id]
        );
      };
    }
  ]);
